<template>
  <div class="card mb-4" id="headings">
    <div class="card-header">
      <h3>Headings</h3>
    </div>
    <div class="card-body">
      <h1>h1. Titolo 1</h1>
      <h2>h2. Titolo 2</h2>
      <h3>h3. Titolo 3</h3>
      <h4>h4. Titolo 4</h4>
      <h5>h5. Titolo 5</h5>
      <h6>h6. Titolo 6</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "Headings",
};
</script>
